import { plainToClass } from 'class-transformer';
import { ConstantsService } from 'app/services/constants-service';
import { Injectable } from '@angular/core';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ApplicationActivity, TimeKeepingActivity } from 'app/admin/applicationactivity/application-activity.model';

@Injectable()
export class ApplicationActivityService {
    constructor(private requestService: ObservableRequestService) {
    }

    getApplicationActivities() {
        return this.requestService.getRequest(ConstantsService.APPLICATION_ACTIVITIES).map(response => {
            return plainToClass(ApplicationActivity, response.arrResult as Object);
        });
    }

    saveTimeKeepingActivity(timeKeepingActivity: TimeKeepingActivity) {
        return this.requestService.putRequest(ConstantsService.APPLICATION_ACTIVITIES,
            JSON.stringify(timeKeepingActivity),
            this.requestService.getJSONContentType());
    }

    addTimeKeepingActivity(timeKeepingActivity: TimeKeepingActivity) {
        return this.requestService.postRequest(ConstantsService.APPLICATION_ACTIVITIES,
            JSON.stringify(timeKeepingActivity),
            this.requestService.getJSONContentType());
    }

    deleteApplicationActivity(id: number) {
        return this.requestService.deleteRequest(`${ConstantsService.APPLICATION_ACTIVITIES}/${id}`,
            null, this.requestService.getJSONContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/applicationactivity/application-activity.service.ts